declare global {
  interface Window {
    Chargify: new () => Chargify;
  }
}

export enum ChargifyPaymentType {
  CARD = 'card',
  BANK = 'bank',
  PAYPAL = 'paypal',
}

export interface ChargifyFieldConfig {
  selector: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  message?: string;
  maxlength?: string;
  style?: ChargifyStyle;
}

export interface ChargifyStyle {
  [selector: string]: ChargifyStyleElement | undefined;
  field?: ChargifyStyleElement;
  input?: ChargifyStyleElement;
  label?: ChargifyStyleElement;
  message?: ChargifyStyleElement;
}

export interface ChargifyStyleElement {
  backgroundColor?: string;
  padding?: string;
  marginBottom?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  borderRadius?: string;
  border?: string;
  transition?: string;
  fontSize?: string;
  color?: string;
  fontFamily?: string;
  fontWeight?: string;
  outline?: string;
  width?: string;
  height?: string;
  boxSizing?: string;
  display?: string;
  flexDirection?: string;
  textAlign?: string;
  verticalAlign?: string;
  position?: string;
  zIndex?: string;
  overflow?: string;
}

export interface ChargifyConfig {
  selector?: string;
  publicKey: string;
  type: ChargifyPaymentType;
  serverHost: string;
  fields?: Record<string, ChargifyFieldConfig>;
  style?: ChargifyStyle;
  requiredLabel?: string;
  optionalLabel?: string;
  creditCardExpirationDateDropdowns?: boolean;
  hideCardImage?: boolean;
  currency?: string;
  addressDropdowns?: boolean;
}

export interface ChargifyToken {
  id: string;
  token: string;
  card?: {
    lastFour: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
  };
}

export interface ChargifyError {
  type: string;
  message: string;
  errors?: string;
}

export type ChargifySuccessCallback = (token: ChargifyToken | string) => void;
export type ChargifyErrorCallback = (error: ChargifyError) => void;

export declare class Chargify {
  constructor();

  load(config: ChargifyConfig): void;

  token(
    form: HTMLFormElement,
    successCallback: ChargifySuccessCallback,
    errorCallback: ChargifyErrorCallback
  ): void;
}
